enum BoundaryLegendType {
  DEMOGRAPHIC = "demographic", // non-record data, e.g. population or income census data
  RECORD = "record", // focus on record data, e.g. monetary or numeric fields
}

export default BoundaryLegendType;
